import React, { useEffect, useRef, useState } from 'react'
import { translate } from '../../../../../../../utils/language'
function Toggle({ setItem, value, id, targetKey, options, componentType, isWidgetItem, hideBorder, className, toggleClass }) {
  const ref = useRef()
  const textRef = useRef()
  const [isChecked, setChecked] = useState(value);
  useEffect(() => {
    if (ref.current)
      ref.current.checked = value
    setChecked(value)
  }, [id, value])

  const handleToggle = () => {
    setItem(!isChecked, targetKey)
    setChecked(!isChecked);
  };
  return (
    <div className={`${isWidgetItem || hideBorder ? "border-b-0" : "border-b-1"} text-left  py-2 pt-2 range pb-[20px] w-full flex flex-row ${className}`}>
      {!isWidgetItem && <p className='text-sm pt-[10px] py-2 text-[#8A92A6] text-[15px] font-medium'>{translate(`${componentType}.${targetKey}`)}</p>}
      <label className={`relative inline-flex items-center cursor-pointer m-auto mr-0 ${toggleClass}`}>
        <input onChange={handleToggle} ref={ref} type="checkbox" className="sr-only peer" style={{ display: "none" }} />
        <div className=" w-[30px] h-[18px] bg-[#C4C8D2] peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[##7059EF] dark:peer-focus:ring-[##7059EF] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[1px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[14px] after:w-[14px] after:transition-all dark:border-gray-600 peer-checked:bg-[#7059EF] duration-300"></div>
      </label>
    </div>

  )
}

export default Toggle